<template>
  <div @click.stop="emmitCardClick()" class="product-card" v-if="!error">
    <div class="product-card-image-container">
      <div class="wishlist-icon-container">
        <wishlist-component :product="product"></wishlist-component>
      </div>
      <div
        class="thumbnail"
        :style="{
          backgroundImage: `url(${getProductImageLowRes(
            product.imageSources[0],
            product.store
          )})`
        }"
      >
        <img
          id="img"
          class="img"
          sizes="(max-width: 767px) calc(50vw - 36px), (min-width: 768px) and (max-width: 1280px) calc(25vw - 64px), 284px"
          :src="
            `${getProductImageLowRes(product.imageSources[0], product.store)}`
          "
          @error="imageError"
        />
      </div>
      <div v-if="product.priceSale" class="sale-banner">
        {{ getSalePercentage }}
      </div>
      <div v-if="product.sustainable" class="sustainable-banner"></div>
    </div>
    <div class="product-card-description">
      <span class="brand">{{ product.brand }}</span>
      <span class="name">{{ product.name }}</span>
      <div class="price-container">
        <span class="sale-price"> {{ product.priceSale | currency }}</span>
        <span :class="{ 'price-crossed-out': isOnSale }">
          {{ product.priceOriginal | currency }}
        </span>
      </div>
      <div class="store-container">
        <div class="store-logo"></div>
        <span>{{ `store.${product.store}` | translate | capitalize }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductSalePercentage, productImageResizer } from "../../mixins";
import WishlistComponent from "../atoms/wishlist-component";
import $ from "jquery";

export default {
  name: "product-card",
  components: { WishlistComponent },
  mixins: [getProductSalePercentage, productImageResizer],
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      error: false
    };
  },
  methods: {
    emmitCardClick() {
      this.$emit("card-clicked", this.product);
    },
    imageError() {
      this.error = true;
    },
    wishListProductClicked() {}
  },
  computed: {
    isOnSale() {
      return !!this.product.priceSale;
    }
  },
  mounted() {
    var width = -1;
    var ratio = 1.35;

    $(".img").each(function() {
      width = width > $(this).width() ? width : $(this).width();
    });

    $(".img").each(function() {
      $(this).height(ratio * width);
    });

    $(window).resize(function() {
      var width = -1;
      $(".img").each(function() {
        width = width > $(this).width() ? width : $(this).width();
      });
      $(".img").each(function() {
        $(this).height(ratio * width);
      });
    });
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.product-card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem;
  justify-content: flex-start;
}

.product-card-image-container {
  position: relative;
}

.sale-banner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 25%;
  height: 10%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: $gyra-red;
  font-size: 2vw;
  @media (min-width: 640px) {
    font-size: 1vw;
  }
}

.store {
  &-container {
    display: flex;
    align-items: center;

    span {
      margin: 0 !important;
    }
  }

  &-logo {
    width: 0.75rem;
    height: 0.75rem;
    background-color: $brand-gray;
    border-radius: 50%;
    margin-right: 0.5rem;
  }
}

.product-card-description {
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;

  span {
    text-overflow: ellipsis;
    font-size: $font-xs;
    margin-bottom: 0.25rem;
  }

  .brand {
    font-family: "Lora";
    font-size: $font-xs;
  }

  .name {
    font-size: $font-xs;
    font-family: "Montserrat-Bold";
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price-container {
    margin-top: -0.25rem;
    margin-bottom: 0.125rem;
  }

  .sale-price {
    font-weight: bold;
    color: $gyra-red;
    margin-right: 0.25rem;
  }
}

.price-crossed-out {
  text-decoration: line-through;
}

.wishlist-icon-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0.25rem;
}

.thumbnail {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  width: 100%;

  img {
    visibility: hidden;
    width: 100%;
  }
}
</style>
